import ResponsiveModal from './ResponsiveModal'

import './responsiveModal.scss'

const ProResponsiveModal = props => <ResponsiveModal modalType='pro-responsive-modal-content' {...props} />

export default ProResponsiveModal
